export default __webpack_public_path__ + "static/media/pic8.70d2f989.jpg";